(function () {
  function setLabel(button, paused) {
    var label = paused
      ? button.getAttribute('data-play-label')
      : button.getAttribute('data-pause-label');
    if (label) {
      button.setAttribute('aria-label', label);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.scrolling-text--toggle').forEach(function (button) {
      if (button.dataset.scrollingTextReady === 'true') {
        return;
      }
      button.dataset.scrollingTextReady = 'true';

      var container = button.closest('.scrolling-text');
      if (!container) {
        return;
      }

      var prefersReducedMotion =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        container.classList.add('is-paused');
        setLabel(button, true);
      }

      button.addEventListener('click', function () {
        var paused = container.classList.toggle('is-paused');
        setLabel(button, paused);
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();